const tasksOverview = {
	tasksHeader: 'Úkoly a informace',
	noTaskFound: 'Na základě zadaných údajů nebyl nalezen žádný úkol ani informace.',
	progressMessage:
		' Probíhá zpracování, vyčkejte prosím na aktualizaci stránky. Zůstává zpracovat {{contactNumber}} položek.',
};

const quickFilter = {
	all: 'Všechny',
	tasks: 'Úkoly',
	info: 'Informace',
	processed: 'Zpracované',
};

const taskTable = {
	taskId: 'ID úkolu',
	informationId: 'ID informace',
	taskSubtype: 'Podtyp / Důvod kontaktování',
	informationSubtype: 'Podtyp / Důvod kontaktování',
	deadline: 'Termín splnění',
	product: 'Produkt',
	clientName: 'Klient',
	policyNo: 'Číslo PS',
	address: 'Adresa',
	policyAdmins: 'Správce PS',
	selectAll: 'Označit vše',
	unselectAll: 'Odznačit vše',
	dateCreated: 'Datum vytvoření',
	inactivePolicyAdmin: 'Neaktivní obchodník',
};

const form = {
	id: 'ID úkolu',
	taskType: 'Typ úkolu',
	taskSubType: 'Podtyp / Důvod kontaktování',
	finishTypeId: 'Splnění úkolu',
	policyNo: 'Číslo PS',
	productArea: 'Produktová oblast',
	deadlineFrom: 'Termín splnění od',
	deadlineTo: 'Termín splnění do',
	surname: 'Příjmení klienta',
	firstName: 'Jméno klienta',
	businessName: 'Název klienta',
	newTask: 'Nepřiřazen – Nový úkol',
	proposalNo: 'Číslo návrhu PS',
};

export default {
	...form,
	...tasksOverview,
	...quickFilter,
	...taskTable,
};
